<template>
  <div class="performance-historical">
    <div v-if="isLoading">
      <SpinnerLoader data-testid="performance-loader" :size="48" />
    </div>
    <div v-else data-testid="performance-by-year">
      <PerformanceByYear
        v-for="year in historical.years"
        :key="year.value"
        :historical="year"
        :benchmark-selected="benchmarkSelected"
        :benchmark-comparison-selected="benchmarkComparisonSelected"
        @show-details="handleShowDetails"
      />
      <PerformanceDetail
        :show-modal="showModal"
        :details="details"
        :benchmark-selected="benchmarkSelected"
        :benchmark-comparison-selected="benchmarkComparisonSelected"
        @close="showModal = false"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import {
  IMonthly,
  IPerformanceHistorical
} from '@/modules/investments/types/Performance';
import PerformanceByYear from '@/modules/investments/views/Performance/components/PerformanceHistorical/components/PerformanceByYear/PerformanceByYear.vue';
import PerformanceDetail from '@/modules/investments/views/Performance/components/PerformanceHistorical/components/PerformanceDetail/PerformanceDetail.vue';
import { SpinnerLoader } from '@warrenbrasil/nebraska-web';
import { ref } from 'vue';
interface Props {
  historical: IPerformanceHistorical;
  isLoading: boolean;
  benchmarkSelected: string;
  benchmarkComparisonSelected: string;
}

defineProps<Props>();

const showModal = ref(false);
const details = ref();

const handleShowDetails = (value: IMonthly) => {
  showModal.value = true;
  details.value = value;
};
</script>
<style lang="less" scoped>
.performance-historical {
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: @size-spacing-x1200;
  }
}
</style>
